// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"_3CQKry","heading":"_47U7df","searchResults":"_1ltyMk","noSearch":"_2NXkrI","noResults":"_3OZC8B","searchResults--mobile":"_24ZR1g"};